// ** React Imports
import { lazy } from 'react'

const OperatorLogin = lazy(() => import('../../views/authentication/OperatorLogin'))
const OperatorRegister = lazy(() => import('../../views/authentication/OperatorRegister'))
const OperatorDashboard = lazy(() => import('../../views/bus-operator-portal/dashboard'))
const OperatorChangePassword = lazy(() => import('../../views/bus-operator-portal/change-password'))
const OperatorRouteApplications = lazy(() => import('../../views/bus-operator-portal/route-applications'))
const OperatorRoutesPastApplications = lazy(() => import('../../views/bus-operator-portal/routes/past-applications'))
const OperatorNewApplications = lazy(() => import('../../views/bus-operator-portal/route-applications/new'))
const OperatorRouteApplicationsApply = lazy(() => import('../../views/bus-operator-portal/route-applications/apply'))
const OperatorRouteApplicationsApplyForm = lazy(() => import('../../views/bus-operator-portal/route-applications/apply/form'))
const OperatorRouteApplicationsDetails = lazy(() => import('../../views/bus-operator-portal/route-applications/details'))
const OperatorRouteApplicationsDecisionView = lazy(() => import('../../views/bus-operator-portal/route-applications/decision-view'))
const OperatorRouteApplicationsPastApplications = lazy(() => import('../../views/bus-operator-portal/route-applications/past-applications'))
const OperatorBusInspections = lazy(() => import('../../views/bus-operator-portal/bus-inspections'))
const OperatorBusInspectionsApply = lazy(() => import('../../views/bus-operator-portal/bus-inspections/apply'))
const OperatorBusInspectionsRouteSelection = lazy(() => import('../../views/bus-operator-portal/bus-inspections/apply/RouteSelection'))
const OperatorBusInspectionsScheduleSelection = lazy(() => import('../../views/bus-operator-portal/bus-inspections/apply/ScheduleSelection'))
const OperatorBusInspectionsBusInspectionForm = lazy(() => import('../../views/bus-operator-portal/bus-inspections/apply/BusInspectionForm'))

const OperatorBusInspectionsNew = lazy(() => import('../../views/bus-operator-portal/bus-inspections/new'))
const OperatorBusInspectionsDetails = lazy(() => import('../../views/bus-operator-portal/bus-inspections/details'))
const OperatorBusInspectionsViewReport = lazy(() => import('../../views/passenger-bus/bus-inspections/applications/view-report'))
const OperatorBusInspectionsPastApplications = lazy(() => import('../../views/bus-operator-portal/bus-inspections/past-applications'))
const OperatorRoutePermits = lazy(() => import('../../views/bus-operator-portal/route-permits'))
const OperatorRoutePermitsApply = lazy(() => import('../../views/bus-operator-portal/route-permits/apply'))
const OperatorRoutePermitsNew = lazy(() => import('../../views/bus-operator-portal/route-permits/new'))
const OperatorRoutePermitsDetails = lazy(() => import('../../views/bus-operator-portal/route-permits/details'))
const OperatorRoutePermitsPastApplications = lazy(() => import('../../views/bus-operator-portal/route-permits/past-applications'))
const OperatorRouteSuspensions = lazy(() => import('../../views/bus-operator-portal/route-suspensions'))
const OperatorRouteSuspensionsApply = lazy(() => import('../../views/bus-operator-portal/route-suspensions/apply'))
const OperatorRouteSuspensionsNew = lazy(() => import('../../views/bus-operator-portal/route-suspensions/new'))
const OperatorRouteSuspensionsDetails = lazy(() => import('../../views/bus-operator-portal/route-suspensions/details'))
const OperatorRouteSuspensionsPastApplications = lazy(() => import('../../views/bus-operator-portal/route-suspensions/past-applications'))
const OperatorRouteCancellations = lazy(() => import('../../views/bus-operator-portal/route-cancellations'))
const OperatorRouteCancellationsApply = lazy(() => import('../../views/bus-operator-portal/route-cancellations/apply'))
const OperatorRouteCancellationsNew = lazy(() => import('../../views/bus-operator-portal/route-cancellations/new'))
const OperatorRouteCancellationsDetails = lazy(() => import('../../views/bus-operator-portal/route-cancellations/details'))
const OperatorRouteCancellationsPastApplications = lazy(() => import('../../views/bus-operator-portal/route-cancellations/past-applications'))

const OperatorRoutes = [
  {
    path: '/bus-operator-portal/login',
    element: <OperatorLogin />,
    meta: {
      layout: 'blank',
      publicRoute: true,
      restricted: true
    }
  },
  {
    path: '/bus-operator-portal/register',
    element: <OperatorRegister />,
    meta: {
      layout: 'blank',
      publicRoute: true,
      restricted: true
    }
  },
  {
    path: '/bus-operator-portal/change-password',
    element: <OperatorChangePassword />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'read',
      resource: 'OperatorDashboard'
    }
  },
  {
    path: '/bus-operator-portal/dashboard',
    element: <OperatorDashboard />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'read',
      resource: 'OperatorDashboard'
    }
  },
  {
    path: '/bus-operator-portal/route-applications/new',
    element: <OperatorNewApplications />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'manage',
      resource: 'OperatorRouteApplications'
    }
  },
  {
    path: '/bus-operator-portal/route-applications/apply',
    element: <OperatorRouteApplicationsApply />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'manage',
      resource: 'OperatorRouteApplications'
    }
  },
  {
    path: '/bus-operator-portal/route-applications/apply/form',
    element: <OperatorRouteApplicationsApplyForm />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'manage',
      resource: 'OperatorRouteApplications'
    }
  },
  {
    path: '/bus-operator-portal/route-applications/details/:id',
    element: <OperatorRouteApplicationsDetails />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'read',
      resource: 'OperatorRouteApplications'
    }
  },
  {
    path: '/bus-operator-portal/route-applications/decision-view/:id',
    element: <OperatorRouteApplicationsDecisionView />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'read',
      resource: 'OperatorRouteApplications'
    }
  },
  {
    path: '/bus-operator-portal/route-applications/past-applications',
    element: <OperatorRouteApplicationsPastApplications />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'read',
      resource: 'OperatorRouteApplications'
    }
  },
  {
    path: '/bus-operator-portal/bus-inspections',
    element: <OperatorBusInspections />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'read',
      resource: 'OperatorBusInspections'
    }
  },
  {
    path: '/bus-operator-portal/bus-inspections/apply',
    element: <OperatorBusInspectionsApply />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'manage',
      resource: 'OperatorBusInspections'
    }
  },
  {
    path: '/bus-operator-portal/bus-inspections/apply/route-selection',
    element: <OperatorBusInspectionsRouteSelection />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'manage',
      resource: 'OperatorBusInspections'
    }
  },
  {
    path: '/bus-operator-portal/bus-inspections/apply/schedule-selection',
    element: <OperatorBusInspectionsScheduleSelection />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'manage',
      resource: 'OperatorBusInspections'
    }
  },
  {
    path: '/bus-operator-portal/bus-inspections/apply/bus-inspection-form',
    element: <OperatorBusInspectionsBusInspectionForm />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'manage',
      resource: 'OperatorBusInspections'
    }
  },
  {
    path: '/bus-operator-portal/bus-inspections/new',
    element: <OperatorBusInspectionsNew />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'manage',
      resource: 'OperatorBusInspections'
    }
  },
  {
    path: '/bus-operator-portal/bus-inspections/details/:id',
    element: <OperatorBusInspectionsDetails />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'read',
      resource: 'OperatorBusInspections'
    }
  },
  {
    path: '/bus-operator-portal/bus-inspections/applications/:id/report',
    element: <OperatorBusInspectionsViewReport />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'read',
      resource: 'OperatorBusInspections'
    }
  },
  {
    path: '/bus-operator-portal/bus-inspections/past-applications',
    element: <OperatorBusInspectionsPastApplications />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'read',
      resource: 'OperatorBusInspections'
    }
  },
  {
    path: '/bus-operator-portal/route-permits',
    element: <OperatorRoutePermits />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'read',
      resource: 'OperatorRoutePermits'
    }
  },
  {
    path: '/bus-operator-portal/route-permits/apply',
    element: <OperatorRoutePermitsApply />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'manage',
      resource: 'OperatorRoutePermits'
    }
  },
  {
    path: '/bus-operator-portal/route-permits/new',
    element: <OperatorRoutePermitsNew />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'read',
      resource: 'OperatorRoutePermits'
    }
  },
  {
    path: '/bus-operator-portal/route-permits/details/:id',
    element: <OperatorRoutePermitsDetails />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'read',
      resource: 'OperatorRoutePermits'
    }
  },
  {
    path: '/bus-operator-portal/route-permits/past-applications',
    element: <OperatorRoutePermitsPastApplications />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'read',
      resource: 'OperatorRoutePermits'
    }
  },
  {
    path: '/bus-operator-portal/route-suspensions',
    element: <OperatorRouteSuspensions />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'read',
      resource: 'OperatorRouteSuspensions'
    }
  },
  {
    path: '/bus-operator-portal/route-suspensions/apply',
    element: <OperatorRouteSuspensionsApply />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'manage',
      resource: 'OperatorRouteSuspensions'
    }
  },
  {
    path: '/bus-operator-portal/route-suspensions/new',
    element: <OperatorRouteSuspensionsNew />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'read',
      resource: 'OperatorRouteSuspensions'
    }
  },
  {
    path: '/bus-operator-portal/route-suspensions/details/:id',
    element: <OperatorRouteSuspensionsDetails />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'read',
      resource: 'OperatorRouteSuspensions'
    }
  },
  {
    path: '/bus-operator-portal/route-suspensions/past-applications',
    element: <OperatorRouteSuspensionsPastApplications />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'read',
      resource: 'OperatorRouteSuspensions'
    }
  },
  {
    path: '/bus-operator-portal/route-cancellations',
    element: <OperatorRouteCancellations />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'read',
      resource: 'OperatorRouteCancellations'
    }
  },
  {
    path: '/bus-operator-portal/route-cancellations/apply',
    element: <OperatorRouteCancellationsApply />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'manage',
      resource: 'OperatorRouteCancellations'
    }
  },
  {
    path: '/bus-operator-portal/route-cancellations/new',
    element: <OperatorRouteCancellationsNew />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'manage',
      resource: 'OperatorRouteCancellations'
    }
  },
  {
    path: '/bus-operator-portal/route-cancellations/details/:id',
    element: <OperatorRouteCancellationsDetails />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'read',
      resource: 'OperatorRouteCancellations'
    }
  },
  {
    path: '/bus-operator-portal/route-cancellations/past-applications',
    element: <OperatorRouteCancellationsPastApplications />,
    meta: {
      layout: 'vertical',
      publicRoute: false,
      operatorRoute: true,
      action: 'read',
      resource: 'OperatorRouteCancellations'
    }
  }
]

export default OperatorRoutes
